module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"links":{"help":"Help","notifications":"Notifications","profile":"Profile","logout":"Sign out","settings":"Settings","switch":"Switch account"}}}')
  delete Component.options._Ctor
}
